import { Image } from 'antd';
import { convertCentsIntoDollar, formatDate } from '../../../helpers/genericHelper';
import CustomText from '../../CustomText';

function ActiveSubscriptions({ activeSubscriptions = [], loading }) {
  return (
    <div className="ant-list-box trans table-responsive" style={{ maxHeight: 400 }}>
      <table className="width-100">
        <thead>
          <tr>
            <th>Icon</th>
            <th>Merchant Id</th>
            <th>Display Name</th>
            <th>Last Transaction Date</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {activeSubscriptions && activeSubscriptions.map((data) => {
            return (
              <tr>
                <td>
                  <Image
                    resizeMode={'contain'}
                    src={data.iconUrl}
                    className={'merchant-image'}
                    preview={false}
                  />
                </td>
                <td>
                  <CustomText
                    dataSet={data}
                    property1={'merchantId'}
                  />
                </td>
                <td>
                  <CustomText
                    dataSet={data}
                    property1={'displayName'}
                  />
                </td>
                <td>
                  <CustomText
                    dataSet={data}
                    property1={'lastTransactionDate'}
                    formatter={formatDate}
                  />
                </td>
                <td>
                  <CustomText
                    dataSet={data}
                    property1={'subscriptionAmountInCents'}
                    formatter={convertCentsIntoDollar}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ActiveSubscriptions;
